import styled, { css } from "styled-components";
import { SortSegCellWrapper } from "../../../Common";
import { colorTwoBright, colorTwoDark } from "../../../../globalStyles";

const getActivePolygonRule = (className: string, color: string) => {
    return css`
    &.${className} {
      background-color: ${color};

      .ant-radio-wrapper {
        color: white;

        .ant-radio {
          &.ant-radio-checked {
            .ant-radio-inner {
              border-color: ${color};
            }
          }

          &:hover,
          &:focus {
            .ant-radio-inner {
              border-color: ${color};
            }
          }

          .ant-radio-input {
            &:focus + .ant-radio-inner {
              border-color: ${color};
            }
          }

          .ant-radio-inner {
            &:after {
              background-color: ${color};
            }
          }
        }
      }
    }
  `;
};

export const SortSegCellWrapperWithActivePolygon = styled(SortSegCellWrapper)`
  ${getActivePolygonRule("polygonOneActive", colorTwoBright)}
  ${getActivePolygonRule("polygonTwoActive", colorTwoDark)}
`;
